class PresseticketcodeController {
  constructor($rootScope, toastr, emittentenService, $location, $anchorScroll) {
    "ngInject";
    this.name = 'presseticketcode';
    this.toastr = toastr;
    this.emittentenService = emittentenService;
    this.$location = $location;
    this.$anchorScroll = $anchorScroll;
    this.disabled = [false, true];
    this.active = 0;
    this.emailChecked = true;
    this.form = {
      adresse_land: '55',
      user_type: 6
    };

    emittentenService.getCountries($rootScope.language).then((result) => {
      this.countries = result;
      return result;
    }, (response) => {
      console.error(response);
    });
  }

  nextTab(index, data) {
    this.disabled[index] = false;
    this.active = index;
    if (index == 2) {
      data.c = 'anmeldung.Teilnehmer';
      data.section = 2;
      data.anmeldung_typ = 1;

      if (data.person_unternehmenstitel_add) {
        data.person_unternehmenstitel = data.person_unternehmenstitel_add;
      }

      if (data.teilnehmer_branche_add) {
        data.teilnehmer_branche = data.teilnehmer_branche_add;
      }

      if (data.teilnehmer_gebuehren2) {
        data.teilnehmer_gebuehren2 = 1;
      }

      this.emittentenService.setData(data).then((result) => {
        if (result && result.code) {
          this.active = 0;
          this.toastr.error(result.msg || 'Unbekannter Fehler. Bitte später erneut versuchen und/oder an eigenkapitalforum@deutsche-boerse.com wenden. ||| Unknown Error. Please try again later and/or email to eigenkapitalforum@deutsche-boerse.com');
          this.showError = true;
          this.errMsg = result.msg || 'Unbekannter Fehler. Bitte später erneut versuchen und/oder an eigenkapitalforum@deutsche-boerse.com wenden. ||| Unknown Error. Please try again later and/or email to eigenkapitalforum@deutsche-boerse.com';
          this.$location.hash('alert');
          this.$anchorScroll();
        } else {
          this.toastr.remove()
          this.toastr.clear()
          this.done = true;
          this.toastr.success('Die Anmeldung wurde erfolgreich abgeschickt. Eine Bestätigung wurde an ' + this.form.person_email + ' gesendet.');
          this.form = {
            user_type: 6
          };
          this.disabled = [false, true];
          this.active = 0;
        }
      });
    }
  }

  selectIndustry() {
    if(this.form.teilnehmer_industriegruppe_branche != 'misc') {
      var selected = $.grep(this.industries, (e) => { return e.id == this.form.teilnehmer_industriegruppe_branche; });
      this.subindustries = selected[0].industriegruppen;
    }else{
      this.subindustries = [];
    }
  }

  checkEmail(email) {
    this.emittentenService.checkEmail(email).then(
      (result) => {
        this.emailChecked = result;
      },
      (response) => {
        console.error(response);
      }
    );
  }
}

export default PresseticketcodeController;



// WEBPACK FOOTER //
// ./client/app/common/forms/presseticketcode/presseticketcode.controller.js